import React, { useEffect, useState } from 'react';
import './Dashboard.css';
import { useNavigate } from "react-router-dom";
import { auth, database } from '../../utils/firebase';
import { ref, onValue, remove, set } from 'firebase/database';
import { Alert, Button } from "@mui/joy";
import SuccessAlert from "../reusable_elements/SuccessAlert";
import {Add, Settings} from "@mui/icons-material";

const Dashboard = () => {
    const navigate = useNavigate();
    const userId = auth.currentUser.uid;
    const userRef = ref(database, `people/${userId}`);
    const userEmail = auth.currentUser.email.replace(/\./g, ",");
    const rawUserEmail = auth.currentUser.email;
    const invitesRef = ref(database, `invites/${userEmail}`);

    const [userFirstName, setUserFirstName] = useState('');
    const [userLastName, setUserLastName] = useState('');
    const [timeOfDay, setUserTimeOfDay] = useState('');
    const [leagueIds, setLeagueIds] = useState([]);
    const [leagues, setLeagues] = useState({});
    const [invites, setInvites] = useState([]);

    const [successAlertOpen, setSuccessAlertOpen] = useState(false);

    useEffect(() => {
        onValue(userRef, (snapshot) => {
            const userData = snapshot.val();
            setUserFirstName(userData.nameFirst);
            setUserLastName(userData.nameLast);
            setLeagueIds(userData.leagues ? Object.keys(userData.leagues) : []);
        });
    }, []);

    useEffect(() => {
        leagueIds.forEach((leagueId) => {
            const leagueRef = ref(database, `leagues/${leagueId}`);
            onValue(leagueRef, (snapshot) => {
                setLeagues(prevLeagues => ({
                    ...prevLeagues,
                    [leagueId]: snapshot.val()
                }));
            });
        });
    }, [leagueIds]);

    useEffect(() => {
        onValue(invitesRef, (snapshot) => {
            const invitesData = snapshot.val();
            if (!invitesData || Object.keys(invitesData).length === 0) {
                setInvites([]); // Ensure it's cleared if there are no invites
                return;
            }

            const inviteList = Object.keys(invitesData).map((leagueId) => {
                const leagueRef = ref(database, `leagues/${leagueId}`);
                onValue(leagueRef, (snapshot) => {
                    const leagueInfo = snapshot.val();
                    setInvites(prevInvites => [
                        ...prevInvites,
                        {
                            id: leagueId,
                            name: leagueInfo?.name || "Unknown League",
                            location: leagueInfo?.parentGroup || "Unknown Location",
                            role: invitesData[leagueId]
                        }
                    ]);
                });
            });
            console.log(inviteList);
        });
    }, []);

    const handleAcceptInvite = (leagueId, role) => {
        const adminRef = ref(database, `leagues/${leagueId}/admins/${userId}`);
        set(adminRef, { userId, role: role, name: userFirstName + " " + userLastName, email: rawUserEmail }).then(() => {
            remove(ref(database, `leagues/${leagueId}/admins/${userEmail}`)); // Remove admin if they were one
            const userLeaguesRef = ref(database, `people/${userId}/leagues/${leagueId}`);
            set(userLeaguesRef, {admin: true, player: false}).then(() => {
                remove(ref(database, `invites/${userEmail}/${leagueId}`)).then(() => {
                    setSuccessAlertOpen(true);
                    setTimeout(() => {
                        setSuccessAlertOpen(false);
                    }, 10000); // 10 seconds delay
                });
            });
        });
    };

    const handleDenyInvite = (leagueId) => {
        remove(ref(database, `invites/${userEmail}/${leagueId}`));
        remove(ref(database, `leagues/${leagueId}/admins/${userEmail}`)); // Remove admin if they were one
    };

    useEffect(() => {
        const date = new Date();
        const hours = date.getHours();
        setUserTimeOfDay(hours < 12 ? 'Morning' : hours < 18 ? 'Afternoon' : 'Evening');
    }, []);

    const handleCloseSuccessAlert = () => {
        setSuccessAlertOpen(false);
    };

    return (
        <div className="container">
            <div className="dashboard-header">
                <h1>Good {timeOfDay} {userFirstName}!</h1>
                <Button variant={"plain"} onClick={() => navigate('/auth/account/utils/preferences/update')}>
                    <Settings color={"action"}/>
                </Button>
            </div>
            <div> {/* Invites */}
                {invites.length > 0 && invites.map((invite) => (
                    <Alert key={invite.id} variant="soft" color="success" endDecorator={
                        <div>
                            <Button size="sm" variant="solid" color="success" style={{ marginRight: "10px" }}
                                    onClick={() => handleAcceptInvite(invite.id, invite.role)}>
                                Accept
                            </Button>
                            <Button size="sm" variant="outlined" color="danger"
                                    onClick={() => handleDenyInvite(invite.id)}>
                                Deny
                            </Button>
                        </div>
                    }>
                        You have a pending invite to {invite.name} ({invite.location})
                    </Alert>
                ))}
            </div>
            <div className="dashboard">
                <h1>My Golf Leagues</h1>
                <Button onClick={() => navigate('/app/leagueWizard')} className="button-gradient" startDecorator={<Add/>}>New League</Button>
                <div className="dash-league-list">
                    {leagueIds.map((leagueId) => (
                        <div className="dash-league-item" key={leagueId}>
                            {leagues[leagueId]?.name}
                            <div className="dash-league-item-buttons">
                                <Button onClick={() => navigate(`/app/league/${leagueId}/dashboard`)} className="button-gradient">
                                    Admin
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
                {userLastName === "(App)" && <Button onClick={() => navigate('/app/apps/leagueUrlTool')} className="button-gradient">League URL Tool</Button>}
            </div>
                {successAlertOpen &&
                    <div>
                        <SuccessAlert message={"Successfully accepted league invite"} onClose={handleCloseSuccessAlert} />
                    </div>
                }
        </div>
    );
};

export default Dashboard;